import { IPlanModel } from '../../../interfaces';

export const isAccountOnFreeCPAPlan = (
  currentUserPlan: IPlanModel | undefined,
) => {
  return currentUserPlan?.tier === 'Basic';
};
